import { gql } from '@apollo/client';

export const PLAYBOOKS = gql`
  query {
    playbooks {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
